import {Injectable} from "@angular/core";
import _cloneDeep from "lodash/cloneDeep";

@Injectable({
    providedIn: "root"
})
export class ConfigurationService<TConfig> {
    protected _config: TConfig = null;

    public get config(): TConfig {
        return _cloneDeep(this._config) as TConfig;
    }

    public initialize(dataset: DOMStringMap): void {
        /* tslint:disable:no-string-literal */

        const configRaw = dataset["config"];
        if(!configRaw) {
           throw new Error("Configuration isn't provided.");
        }
        this._config = JSON.parse(configRaw) as TConfig;

        /* tslint:enable:no-string-literal */
    }
}
